import type { Asset } from '@ztechapps/common.contract'
import { AssetContainer } from '@ztechapps/webui.data-tools'
import { useMutation } from '@ztechapps/common.hook'
import { taskDocumentQueries } from '@ztechapps/task.common'
import React from 'react'

export type TaskAssetsProps = {
  entityId: string
  assets?: Asset[]
  canEdit?: boolean
}

export const TaskAssets = ({ entityId, assets = [], canEdit = false }: TaskAssetsProps) => {
  const [onUpdate] = useMutation({ query: taskDocumentQueries.updateConfig.query })

  return (
    <AssetContainer
      entityType="Task"
      entityId={entityId}
      assets={assets}
      canEdit={canEdit}
      pdfIcon={''}
      fileIcon={''}
      onReorder={async (value) => {
        await onUpdate({ input: { _id: entityId, ...value } })
      }}
    />
  )
}
